import Main from "../components/layouts/Main";
import PageNotFound from "../pages/PageNotFoundPage/PageNotFound";
import Dashboard from "../pages/DashboardPage/Dashboard";
import PrivateRoute from "./PrivateRoute";
import Profile from "../pages/ProfilePage/Profile";
import Storyboard from "../pages/StoryboardPage/Storyboard";
import DatabaseModel from "../pages/DatabaseModelsPage/DatabaseModel";
import Documentation from "../pages/DocumentationPage/Documentation";
import Studio from "../pages/StudioPage/Studio";
import FormBuilder from "../pages/FormBuilderPage/FormBuilder";
import IDEPage from "../pages/IDEPage/IDEPage";
import TeamMemberPage from "../pages/TeamMemberPage/TeamMemberPage";
import VideoConferencing from "../pages/VideoConferencingPage/VideoConferencing";
import SettingPage from "../pages/SettingsPage/SettingPage";
import ProjectDetails from "../pages/ProjectDetailsPage/ProjectDetails";
import Tasks from "../pages/TasksPage/Tasks";
import Register from "../pages/RegisterPage/Register";
import Login from "../pages/LoginPage/Login";
import Application from "../pages/ApplicationPage/Application";
import D2 from "../pages/D2Page/D2";
import TheiaLogin from "../pages/TheiaLogin/TheiaLogin";
import TeamPage from "../pages/TeamPage/TeamPage";
import Guideline from "../pages/Guideline/Guideline";
const { createBrowserRouter } = require("react-router-dom");

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <PrivateRoute>
        <Main />
      </PrivateRoute>
    ),
    errorElement: <PageNotFound />,
    children: [
      {
        path: "/",
        element: (
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        ),
      },
      {
        path: "/profile",
        element: (
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        ),
      },
      {
        path: "/storyboard",
        element: (
          <PrivateRoute>
            <Storyboard />
          </PrivateRoute>
        ),
      },
      {
        path: "/database",
        element: (
          <PrivateRoute>
            <DatabaseModel />
          </PrivateRoute>
        ),
      },
      {
        path: "/project_details",
        element: (
          <PrivateRoute>
            <ProjectDetails />
          </PrivateRoute>
        ),
      },
      {
        path: "/tasks",
        element: (
          <PrivateRoute>
            <Tasks />
          </PrivateRoute>
        ),
      },
      {
        path: "/documentation",
        element: (
          <PrivateRoute>
            <Documentation />
          </PrivateRoute>
        ),
      },
      {
        path: "/studio",
        element: (
          <PrivateRoute>
            <Studio />
          </PrivateRoute>
        ),
      },
      {
        path: "/form_builder",
        element: (
          <PrivateRoute>
            <FormBuilder />
          </PrivateRoute>
        ),
      },
      {
        path: "/ide",
        element: (
          <PrivateRoute>
            <IDEPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/team_member",
        element: (
          <PrivateRoute>
            <TeamMemberPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/team",
        element: (
          <PrivateRoute>
            <TeamPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/video_conferencing",
        element: (
          <PrivateRoute>
            <VideoConferencing />
          </PrivateRoute>
        ),
      },
      {
        path: "/settings",
        element: (
          <PrivateRoute>
            <SettingPage />
          </PrivateRoute>
        ),
      },
      {
        path: "/application",
        element: (
          <PrivateRoute>
            <Application />
          </PrivateRoute>
        ),
      },
      {
        path: "/d2",
        element: (
          <PrivateRoute>
            <D2 />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: "/theia-login/:name",
    element: <TheiaLogin />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path:"/guide-line",
    element: <Guideline />,
  }
]);
